import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import { useIds } from "../../../../../hook/AdminContext";
import { s3baseUri } from "../../../../../config/config";
import { MapPin } from "lucide-react";
import CustomPopoverSection from "../../../../../components/menu/MebuCustomPopOverSection";
import { delete_coach } from "../../../../../DAL/Coach/coach";
import { enqueueSnackbar } from "notistack";
import CustomConfirmation from "../../../../../components/popUp/CustomConfirmation";
import CompanyPopup from "../../../../../components/popUp/CompanyPopup";
import { show_proper_words } from "../../../../../utils/Constant";
import { address_icon, email_icon } from "../../../../../assets";
import CoachAndLeaderModal from "../../../../Clients/components/CoachAndLeaderModal";
import ActionByChip from "../../../../../components/cards/ActionByChip";

export default function CoachesCard({
  item,
  source_slug,
  type_slug,
  isCrudAllow = true,
  handleOpenEditCoach = () => {},
  handleGetCoaches = () => {},
  overViewType,
}) {
  const { userInfo, handleEmailClick } = useIds();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);

  const handleNavigateDetails = () => {
    setOpenDetails(true);
  };

  const handleDelete = async (coach) => {
    const resp = await delete_coach(coach._id);
    if (resp.code == 200) {
      handleGetCoaches();
      enqueueSnackbar(resp.message, { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setDeleteDialogOpen(false);
  };

  const handleDeleteCoachConfimation = () => {
    setDeleteDialogOpen(true);
  };

  const handleMenuOpions = () => {
    if (
      (userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
      (userInfo?.isCompanyProfile &&
        userInfo?.company_access?.manage_profile?.company_profile)
    ) {
      const MENU_OPTIONS = [
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditCoach(row);
          },
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: () => handleDeleteCoachConfimation(),
        },
      ];
      return MENU_OPTIONS;
    } else {
      return [];
    }
  };

  return (
    <>
      {openDetails && (
        <CoachAndLeaderModal
          companyModalOpen={openDetails}
          handleCloseCompanyModal={() => setOpenDetails(false)}
          companyModalData={item}
          isCoachModal={true}
          companyType={overViewType}
        />
      )}
      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this coach?"}
        headerHeading={"Delete Coach"}
        handleAgree={() => handleDelete(item)}
      />

      <div
        key={item._id}
        className="col-12 col-md-6 col-xl-4 mb-4"
        onClick={() => handleNavigateDetails(item)}
      >
        <div className="blog-card coach-card h-100">
          {item?.client_object?._id === userInfo?.profile_id && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                transform: "rotate(-35deg) translate(-25%, 0%)",
                height: "20px",
                minWidth: "130px",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                lineHeight: "16px",
                zIndex: 1,
                fontSize: "12px",
                backgroundColor: "var(--portal-success-color)", // green success color
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 6px",
              }}
            >
              My Coach
            </div>
          )}
          <div className="" style={{ flexGrow: 1 }}>
            <div className="d-flex mb-1">
              <Avatar
                src={
                  item?.profile_image?.thumbnail_1
                    ? s3baseUri + item?.profile_image?.thumbnail_1
                    : ""
                }
                sx={{ width: 48, height: 48, mr: 1, cursor: "pointer" }}
                alt={item?.company_name}
              />
              <div className="d-flex justify-content-between w-100">
                <div>
                  <h5>
                    <span className="me-2">
                      {item.name || item.leader_title}
                    </span>
                    {item?.profile_type?.name && (
                      <span className={`outlined-chip d-inline-block`}>
                        {item?.profile_type?.name}
                      </span>
                    )}
                  </h5>
                  <span className="podcast-name">{item.company_name}</span>
                </div>

                {item?.client_object?._id === userInfo?.profile_id &&
                  isCrudAllow &&
                  handleMenuOpions().length > 0 && (
                    <CustomPopoverSection
                      menu={handleMenuOpions()}
                      data={item}
                    />
                  )}
              </div>
            </div>
            {(item?.action_by?.first_name || item?.action_by?.company_name) &&
              userInfo?.profile_id === item?.client_object?._id && (
                <div className="d-flex justify-content-end">
                  <ActionByChip
                    className="new-chip new-chip--outlined"
                    actionByName={
                      item?.action_by?.company_name ||
                      `${item?.action_by?.first_name} ${item?.action_by?.last_name}`
                    }
                  />
                </div>
              )}
            {/* <div className={`job-meta-item tw-mt-2`}>
            <MapPin className="job-meta-icon" />
            <span className="job-meta-text">{item.location}</span>
          </div> */}

            <div
              className="text-gray mt-2 description"
              dangerouslySetInnerHTML={{
                __html: item.short_summary || item.leader_short_summary,
              }}
            ></div>
            <ul className="list-unstyled m-0">
              <li className="d-flex align-items-center mt-2">
                <img
                  src={email_icon}
                  alt="website_icon"
                  className="pe-2"
                  height={35}
                  width={35}
                />
                <span>{item.email}</span>
              </li>
              <li className="d-flex align-items-center mt-2">
                <img
                  src={address_icon}
                  alt="website_icon"
                  className="pe-2"
                  height={35}
                  width={35}
                />
                <span>{item.location}</span>
              </li>
            </ul>
          </div>
          <div className="row mt-3 card-action-btns">
            <div className="col-6 pe-0">
              {(userInfo.role == "client" || userInfo?.isCompanyProfile) &&
                item?.client_object?._id !== userInfo?.profile_id &&
                item?.email && (
                  <button
                    className="small-button w-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEmailClick(item?.email);
                    }}
                  >
                    Contact {show_proper_words(overViewType)}
                  </button>
                )}
            </div>
            <div className="col-6 ps-0">
              <button
                className={`sm-outlined-btn !tw-px-4 tw-ms-2 w-100`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNavigateDetails(item);
                }}
              >
                View Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
